import { Marker, Popup } from 'react-leaflet';
import MapMarkerBlueIcon from '@library/assets/images/icons/map-marker-blue.svg';
import { icon as leafletIcon } from 'leaflet';
import { useMemo } from 'react';

export interface MapMarkerProps {
  children: React.ReactNode;
  markerIcon?: string;
  position: [number, number];
}

export const MapMarker = ({
  children,
  markerIcon = MapMarkerBlueIcon,
  position
}: MapMarkerProps) => {
  const icon = useMemo(
    () =>
      leafletIcon({
        iconAnchor: [16, 32],
        iconSize: [32, 32],
        iconUrl: markerIcon
      }),
    [markerIcon]
  );

  return (
    <Marker key={position.join('-')} position={position} icon={icon}>
      <Popup>{children}</Popup>
    </Marker>
  );
};
